import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MuiTypography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import * as mixins from '../../../helpers';
import { logout } from '../../../redux/actions/loginActions';
import { buildAlertaObj, tratarErro } from '../../../helpers/errorHelper';
import { exibeAlerta } from '../../../redux/actions/alertActions';

const BoxSideBarStyle = styled.div`
    display: block;
    justify-content: flex-end;
    background-color: #F1FF00;
    color: #000000;
    padding: ${mixins.setSizes(25)};
`;

const CloseButtonSideBarStyle = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const StyledTypography = withStyles({
    root: {
        display: 'inline-block',
        fontSize: '1.5em',
        fontFamily: 'SimplonHeadline'
    }
})(MuiTypography);

const StyledLogoutTypography = withStyles({
    root: {
        display: 'inline-block',
        float: 'right',
        fontSize: '1em',
        fontFamily: 'SimplonHeadline',
        cursor: 'pointer'
    }
})(MuiTypography);

const CloseButtonSideBar = ({ nome, close }) => {
    const dispatch = useDispatch();

    const localLogout = async () => {
        try {
            await dispatch(logout());
        } catch (error) {
            let alertObj = tratarErro(error);
            if (!alertObj) {
                alertObj = buildAlertaObj(
                    `FALHA NO LOGOUT`,
                    error.response.data.message
                );
            }
            dispatch(exibeAlerta(alertObj));
        }
    };

    return (
        <BoxSideBarStyle>
            <CloseButtonSideBarStyle onClick={close}>
                <div>
                    <StyledTypography>Oi,</StyledTypography>
                    <StyledTypography>{nome}</StyledTypography>
                </div>
                <ChevronLeftIcon fontSize='large' />
            </CloseButtonSideBarStyle>
            <StyledLogoutTypography onClick={localLogout}>
                sair
            </StyledLogoutTypography>
        </BoxSideBarStyle>
    );
};

CloseButtonSideBar.propTypes = {
    nome: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired
};

export default CloseButtonSideBar;
